import { render, staticRenderFns } from "./FormularioMaterial.vue?vue&type=template&id=212c83aa&lang=pug"
import script from "./FormularioMaterial.vue?vue&type=script&lang=js"
export * from "./FormularioMaterial.vue?vue&type=script&lang=js"
import style0 from "./FormularioMaterial.vue?vue&type=style&index=0&id=212c83aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports